import React from 'react';
import { Home, Building, Paintbrush, Hammer, Palette, Briefcase } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: <Home size={40} />,
      title: 'Interior Painting',
      description: 'Transform your indoor spaces with our expert interior painting services. From living rooms to bedrooms, we bring color and life to every corner of your home.'
    },
    {
      icon: <Building size={40} />,
      title: 'Exterior Painting',
      description: 'Protect and beautify your home exterior with weather-resistant paints and professional application techniques that stand the test of time.'
    },
    {
      icon: <Paintbrush size={40} />,
      title: 'Texture Finishes',
      description: 'Add depth and character to your walls with our specialized texture finishes. From subtle elegance to bold statements, we create unique surfaces.'
    },
    {
      icon: <Hammer size={40} />,
      title: 'Renovation & Remodeling',
      description: 'Complete renovation solutions that go beyond paint. We handle structural changes, repairs, and complete space transformations.'
    },
    {
      icon: <Palette size={40} />,
      title: 'Color Consultation',
      description: 'Struggling with color choices? Our experts help you select the perfect palette that complements your style and space.'
    },
    {
      icon: <Briefcase size={40} />,
      title: 'Commercial Projects',
      description: 'Professional painting and renovation services for offices, retail spaces, and commercial properties of all sizes.'
    }
  ];

  return (
    <section id="services" className="services-section section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">Comprehensive Solutions for Every Need</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;